<template>
  <BaseForm
    title="Eine Preis Überschreibung bearbeiten"
    @onConfirmClicked="onConfirmClicked"
  >
    <form>
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="3">
            <v-select
              v-model="data.articleID"
              label="Artikel"
              item-value="id"
              item-text="code"
              :items="articleList"
            ></v-select>
          </v-col>
          <v-col cols="3">
            <v-select
              v-model="data.minMax"
              label="Grenztyp"
              :items="minMaxList"
              required
              item-value="code"
              item-text="name"
            ></v-select>
          </v-col>
          <v-col cols="3">
            <v-select
              v-model="data.type"
              label="Preistyp"
              :items="priceTypeList"
              required
              item-value="code"
              item-text="name"
            ></v-select>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="data.priceThreshold"
              :error-messages="priceThresholdErrors"
              :counter="10"
              label="Preisgrenze"
              required
              suffix="€"
              @input="$v.data.priceThreshold.$touch()"
              @blur="$v.data.priceThreshold.$touch()"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row align="center" justify="center">
          <v-col cols="6">
            <v-text-field
              v-model="data.reason"
              :error-messages="reasonErrors"
              label="Grund (Freitext)"
              required
              @input="$v.data.reason.$touch()"
              @blur="$v.data.reason.$touch()"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row align="center" justify="center" class="ma-3">
          <v-date-picker
            no-title
            v-model="data.valid"
            :error-messages="validErrors"
            label="Gültig"
            range
            @input="$v.data.valid.$touch()"
            @blur="$v.data.valid.$touch()"
          ></v-date-picker>
        </v-row>
        <v-row align="center" justify="center" class="ma-3">
          <v-col cols="3">
            <v-text-field v-model="data.validFrom" label="Von" />
          </v-col>
          <v-col cols="3">
            <v-text-field v-model="data.validTill" label="Bis" />
          </v-col>
        </v-row>
        <v-row align="center" justify="center">
          <v-col cols="3">
            <v-text-field
              v-model="data.createdBy"
              :error-messages="createdByErrors"
              label="Erstellt von"
              readonly
              required
              disabled
              @input="$v.data.createdBy.$touch()"
              @blur="$v.data.createdBy.$touch()"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="item.createdAt"
              label="Erstellt am"
              readonly
              disabled
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </form>
  </BaseForm>
</template>

<script>
import { API } from "aws-amplify";
import { updateOverwriteArticlePrice } from "@/graphql/mutations";
import { listArticles, getOverwriteArticlePrice } from "@/graphql/queries";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import BaseForm from "@/components/baseCrud/BaseForm.vue";

export default {
  name: "app",
  mixins: [validationMixin],
  components: {
    BaseForm,
  },
  data() {
    return {
      item: {},
      data: {},
      minMaxList: [
        {
          id: 1,
          code: "MIN",
          name: "Untergrenze",
        },
        {
          id: 2,
          code: "MAX",
          name: "Obergrenze",
        },
      ],
      priceTypeList: [
        {
          id: 1,
          code: "FIX_PRICE",
          name: "Startpreis",
        },
        {
          id: 2,
          code: "MONTH_PRICE",
          name: "Monatspreis",
        },
      ],
      articleList: [],
    };
  },
  validations: {
    item: {
      validFrom: { required },
      validTill: { required },
      articleID: { required },
      minMax: { required },
      priceThreshold: { required },
      reason: { required },
      createdBy: { required },
    }
  },
  async created() {
    this.setCreatedBy();
    this.getArticleList();
    this.getCurrentItemById(this.currentId);
    this.createdBy = this.kurzel;
  },
  methods: {
    async getCurrentItemById(id) {
      const response = await API.graphql({
        query: getOverwriteArticlePrice,
        variables: { id }
      });
      this.item = response.data.getOverwriteArticlePrice;
    },
    async createMethod() {
      const input = {
        id: this.item.id,
        articleID: this.item.articleID,
        priceThreshold: parseInt(this.item.priceThreshold, 10),
        validFrom: this.item.validFrom,
        validTill: this.item.validTill,
        minMax: this.item.minMax,
        reason: this.item.reason,
        type: this.item.type,
        _version: this.item._version,
      };
      await API.graphql({
        query: updateOverwriteArticlePrice,
        variables: { input: input },
      });
      this.$router.push({ name: "NgwOverwriteArticlePriceList" });
      this.$emit("refresh");
    },
    onConfirmClicked() {
      this.createMethod();
    },
    async getArticleList() {
      this.loading = true;
      const response = await API.graphql({
        query: listArticles,
        variables: {
          limit: 10000,
        },
      });
      this.articleList = response.data.listArticles.items;
      this.loading = false;
    },
    setCreatedBy() {
      if (this.user) {
        this.data.createdBy = this.user.email;
      }
    },
    onCancelClicked() {
      this.$router.go(-1);
    },
    articleDisplayText(item) {
      return `${item.mandatorCode} - ${item.articleCode}`;
    },
  },
  computed: {
    validFrom() {
      return this.item.valid[0];
    },
    validTill() {
      return this.item.valid[1];
    },
    articleErrors() {
      const errors = [];
      if (!this.$v.item.article.$dirty) return errors;
      !this.$v.item.article.required && errors.push("Is required.");
      return errors;
    },
    minMaxErrors() {
      const errors = [];
      if (!this.$v.item.minMax.$dirty) return errors;
      !this.$v.item.minMax.required && errors.push("Is required.");
      return errors;
    },
    priceThresholdErrors() {
      const errors = [];
      if (!this.$v.item.priceThreshold.$dirty) return errors;
      !this.$v.item.priceThreshold.required && errors.push("Is required.");
      return errors;
    },
    reasonErrors() {
      const errors = [];
      if (!this.$v.item.reason.$dirty) return errors;
      !this.$v.item.reason.required && errors.push("Is required.");
      return errors;
    },
    validErrors() {
      const errors = [];
      if (!this.$v.item.valid.$dirty) return errors;
      !this.$v.item.valid.required && errors.push("Is required.");
      return errors;
    },
    createdByErrors() {
      const errors = [];
      if (!this.$v.item.createdBy.$dirty) return errors;
      !this.$v.item.createdBy.required && errors.push("Is required.");
      return errors;
    },
    isApprovedErrors() {
      const errors = [];
      if (!this.$v.item.isApproved.$dirty) return errors;
      !this.$v.item.isApproved.required && errors.push("Is required.");
      return errors;
    },
    approvedByErrors() {
      const errors = [];
      if (!this.$v.item.approvedBy.$dirty) return errors;
      !this.$v.item.approvedBy.required && errors.push("Is required.");
      return errors;
    },
    ...mapGetters(["user", "kurzel"]),
    currentId() {
      return this.$route.params.id;
    },
  },
};
</script>